// import consts
import { dynamicAssets } from 'js/constants/Paths';

export const parseData = (data) => {
  const makeIds = [];
  const makesById = {};

  if (data && data?.length > 0) {
    data.map((item, index) => {
      if (item.cta_image && item.cta_image !== '') {
        item.imageUrl = dynamicAssets(item.cta_image);
      }

      if (item.file_upload && item.file_upload !== '') {
        item.link = dynamicAssets(item.file_upload, false);
      }

      item.type = 'make';

      makeIds.push(item.id);
      makesById[item.id] = item;
    });
  }

  return { makesById, makeIds };
};
